import { item } from './employee_register_data';

export const employee_drawers_b = {
  'E-042': {
    section: 'Employee - E-042 - HR',
    name: 'Lerato Botha',
    subtitle: 'HR Business Partner - HR - joined Jun 2020',
    status: 'Compliant',
    status_class: 'bg-success-subtle text-success-emphasis',
    callout: 'Active employee under Complyon monitoring. Overdue obligations can still re-trigger revalidation in OnboardOS.',
    score: 100,
    score_tone: 'is-green',
    joined: '2024',
    fit_proper: 'N/A',
    open_items: '0',
    chip_groups: [
      ['POPIA / data protection', 'Code of conduct'],
      ['DoA: Off 04 - HR'],
      ['Approve HR records changes', 'No financial authority']
    ],
    primary_items: [
      item('DoA: Off 04 - HR', 'Approved spend routed by Delegation of Authority engine', 'approved', 'success')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 08 Jan 2026', 'accepted', 'success'),
          item('POPIA / data protection', 'Signed 08 Jan 2026', 'accepted', 'success')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('POPIA awareness', 'Completed', 'complete', 'success'),
          item('Cybersecurity awareness', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('No conflicts - 05 Jan 2026', 'Declared: no interests requiring intervention', 'current', 'success')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('HRIS - Admin', 'Last review 17 Jan 2026', 'current', 'success'),
          item('Laptop IT-030', 'Asset check current', 'assigned', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [],
    records: [
      item('DoA Off-04 HR', '', 'assigned', 'neutral'),
      item('A1 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Lerato is current and only needs to stay inside the HR quarterly re-attestation cycle.'
  },
  'E-219': {
    section: 'Employee - E-219 - IT',
    name: 'Kabelo Tau',
    subtitle: 'Senior Engineer - IT - joined Apr 2024',
    status: 'Revalidation',
    status_class: 'bg-danger-subtle text-danger-emphasis',
    callout: 'Originated in OnboardOS. Employee journey: Complyon can monitor ongoing obligations and can re-trigger revalidation when controls slip.',
    score: 60,
    score_tone: 'is-red',
    joined: '2024',
    fit_proper: 'Required',
    open_items: '0',
    chip_groups: [
      ['Information security policy', 'Privileged access training'],
      ['Fit & proper (privileged)'],
      ['Quarterly access review']
    ],
    primary_items: [
      item('DoA: Off 07 - Privileged', 'Approved spend routed by Delegation of Authority engine', 'review', 'warning'),
      item('Privileged production changes', 'Change approvals and operational change windows', 'pending', 'warning')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 12 Feb 2026', 'accepted', 'success'),
          item('Information security', 'Signed 12 Feb 2026', 'accepted', 'success'),
          item('Acceptable use', 'Due 31 May 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('Security awareness', 'Completed', 'complete', 'success'),
          item('Privileged access', 'Due 31 May 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('No conflicts - 27 Apr 2026', 'Declared: no conflicts requiring intervention', 'current', 'success')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Production (root) - Privileged', 'Last review 27 Mar 2026', 'review', 'warning'),
          item('Asset: server token - Admin', 'Last review 19 Mar 2026', 'current', 'success'),
          item('Laptop IT-031', 'Asset check current', 'assigned', 'success'),
          item('Server cabinet (restricted)', 'Last review 17 Mar 2026', 'current', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [
      'Kabelo is in revalidation because privileged access training and acceptable-use attestation are overdue.'
    ],
    records: [
      item('DoA Off-07 - Privileged', '', 'assigned', 'neutral'),
      item('A1 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Suspend elevated approvals until the privileged-access refresher and acceptable-use acknowledgement are completed.'
  },
  'E-175': {
    section: 'Employee - E-175 - Marketing',
    name: 'Nomsa Dube',
    subtitle: 'Marketing Specialist - Marketing - joined Sep 2024',
    status: 'Action required',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    callout: 'Active employee under Complyon monitoring. Overdue obligations can still re-trigger onboarding when items lapse.',
    score: 33,
    score_tone: 'is-red',
    joined: '2024',
    fit_proper: 'N/A',
    open_items: '0',
    chip_groups: [
      ['POPIA / data protection', 'Marketing asset review'],
      ['DoA: Off 08 - Marketing'],
      ['Approve campaign spend <= R250 000']
    ],
    primary_items: [
      item('DoA: Off 08 - Marketing', 'Approved spend routed by Delegation of Authority engine', 'approved', 'success')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 08 Feb 2026', 'accepted', 'success'),
          item('POPIA / data protection', 'Due 30 Jun 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('POPIA awareness', 'Due 30 Jun 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('Annual declaration pending', 'Annual conflict-of-interest attestation', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Marketing platform - Standard', 'Last review 18 Apr 2026', 'current', 'success'),
          item('Laptop IT-032', 'Asset check current', 'assigned', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [
      'Nomsa has two overdue marketing-compliance items and an unsigned annual declaration.'
    ],
    records: [
      item('DoA Off-08 Marketing', '', 'assigned', 'neutral'),
      item('A1 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Complete POPIA awareness and the annual declaration before the next campaign budget review.'
  }
};
